import { atomFamily } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const ocSelectedTabState = atomFamily({
  key: "ocSelectedTabState",
  default: 0,
  effects_UNSTABLE: [ocPersistAtom],
});
